import { useSection } from '@nucleus/web-theme';
import { nucleusClass } from '@nucleus/web-theme-elements';
import classNames from 'classnames';
import React from 'react';
import { BlockLayout } from '../../blockLayouts/Base';
import { BlockPostContent } from '../../blocks/BlockPostContent';
import { getSectionClasses } from '../../lib/classes';
import { Section } from '../../sectionLayouts/Section';
import { SectionLayout } from '../../sectionLayouts/SectionLayout';

export const PostContentSection = (): JSX.Element => {
  const section = useSection();
  const block = section.payload.blocks[0];

  return (
    <Section className={classNames(nucleusClass('section-post-content'), getSectionClasses(section))}>
      <SectionLayout {...section.payload}>
        <BlockLayout {...section.payload}>
          <BlockPostContent {...section.payload} block={block} />
        </BlockLayout>
      </SectionLayout>
    </Section>
  );
};
